import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    CircularProgress,
    Typography,
} from "@mui/material";
import { intl } from 'dmsbasereact';

export const LegalDocumentDialog = ({
    open,
    onClose,
    document,
    loading,
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            scroll="paper"
        >
            <DialogTitle>
                {document?.title || intl.get("LegalDocument").d("Legal Document")}
            </DialogTitle>
            <DialogContent dividers>
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                        <CircularProgress />
                    </Box>
                ) : document ? (
                    <Box
                        sx={{ '& h1, & h2, & h3': { mt: 2, mb: 1 }, '& p': { mb: 1 } }}
                        dangerouslySetInnerHTML={{ __html: document.content }}
                    />
                ) : (
                    <Typography color="text.secondary">
                        {intl.get("DocumentNotAvailable").d("Document not available.")}
                    </Typography>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    {intl.get("Close").d("Close")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
